"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var actions_1 = __importDefault(require("./actions"));
var actions_2 = __importDefault(require("../login/actions"));
var types_1 = require("../app/util/types");
var TrustedBySliver_1 = __importDefault(require("./components/TrustedBySliver"));
var StatisticsSliver_1 = __importDefault(require("./components/StatisticsSliver"));
var FeatureListSliver_1 = __importDefault(require("./components/FeatureListSliver"));
var Section_1 = __importDefault(require("../app/components/Section"));
var LandingGraphicSilver_1 = __importDefault(require("./components/LandingGraphicSilver"));
var LandingPage_1 = __importDefault(require("../app/components/BaseLayout/LandingPage"));
var ga_1 = require("../app/util/ga");
// import initMonitoring from '../app/helpers/monitoring'
// initMonitoring()
var HomePage = function () {
    var dispatch = react_redux_1.useDispatch();
    var getLinksToRotate = function () { return dispatch(actions_1.default.getLinksToRotate()); };
    var getIsLoggedIn = function () { return dispatch(actions_2.default.isLoggedIn()); };
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    // Load once on start
    react_1.useEffect(function () {
        // Google Analytics: Home Page
        ga_1.GAPageView('HOME PAGE');
        ga_1.GAEvent('home page', 'Entering home page');
        getLinksToRotate();
        getIsLoggedIn();
    }, []);
    if (isLoggedIn) {
        return (react_1.default.createElement(react_router_dom_1.Redirect, { to: {
                pathname: types_1.USER_PAGE,
            } }));
    }
    return (react_1.default.createElement(LandingPage_1.default, null,
        react_1.default.createElement(LandingGraphicSilver_1.default, null),
        react_1.default.createElement("div", { id: "landing-bottom" },
            react_1.default.createElement(Section_1.default, { backgroundType: "light", verticalMultiplier: isMobileView ? 0.5 : 1 },
                react_1.default.createElement(TrustedBySliver_1.default, null))),
        react_1.default.createElement("div", { id: "landing-description" },
            react_1.default.createElement(Section_1.default, { backgroundType: "light", verticalMultiplier: isMobileView ? 0.5 : 1 },
                react_1.default.createElement(FeatureListSliver_1.default, null))),
        react_1.default.createElement(Section_1.default, { backgroundType: "goKhNew", applyAppMargins: false, verticalMultiplier: isMobileView ? 0.5 : 1 },
            react_1.default.createElement(StatisticsSliver_1.default, null))));
};
exports.default = HomePage;
